import React from 'react';
import { useRevealInView } from '../lib/landingMotion';
import AnimatedTrackPreview from './AnimatedTrackPreview';

const trackingSignals = [
    'Any exercise',
    'Any unit – reps, time, weight, or create your own',
    'Workouts structured your way',
];

export default function FeaturesSection() {
    const { ref, isVisible } = useRevealInView({ threshold: 0.18, rootMargin: '0px 0px -8% 0px' });

    return (
        <section
            ref={ref}
            className={`landing-section landing-track ${isVisible ? 'is-visible' : ''}`}
            id="track-anything"
            data-reveal-root
        >
            <div className="site-container landing-track__grid">
                <div className="landing-track__visual" data-reveal-item style={{ '--delay': '120ms' }}>
                    <AnimatedTrackPreview isActive={isVisible} />
                </div>

                <div className="landing-copy landing-track__copy">
                    <p className="landing-kicker" data-reveal-item style={{ '--delay': '0ms' }}>
                        Flexible by design
                    </p>

                    <h2 className="landing-display" data-reveal-item style={{ '--delay': '70ms' }}>
                        <span>Track anything</span>
                    </h2>

                    <ul className="landing-bullets" data-reveal-item style={{ '--delay': '150ms' }}>
                        {trackingSignals.map((signal) => (
                            <li key={signal}>
                                <span className="landing-bullets__dot" aria-hidden="true" />
                                <span>{signal}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}
